import axios from 'axios';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function publishApiLogs(_x) {
  return _publishApiLogs.apply(this, arguments);
}
function _publishApiLogs() {
  _publishApiLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(publishLogsRequest) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return axios.post('https://v11-tfw-api.codeparva.com/configurations/publish-logs', {
            'logGroup': 'v10-tfw-logs',
            'logStream': 'api-errors',
            'logMessage': {
              'CID': publishLogsRequest.cid,
              'error': publishLogsRequest.error,
              'message': publishLogsRequest.message,
              'headers': publishLogsRequest.headers,
              'requestBody': publishLogsRequest.requestBody,
              'response': publishLogsRequest.response
            }
          });
        case 3:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          throw _context.t0;
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _publishApiLogs.apply(this, arguments);
}
function publishUserSteps(_x2) {
  return _publishUserSteps.apply(this, arguments);
}
function _publishUserSteps() {
  _publishUserSteps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(publishLogsRequest) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return axios.post('https://v11-tfw-api.codeparva.com/configurations/publish-logs', {
            'logGroup': 'v10-tfw-logs',
            'logStream': 'activity-logs',
            'logMessage': {
              'CID': publishLogsRequest.cid,
              'message': publishLogsRequest.message
            }
          });
        case 3:
          response = _context2.sent;
          return _context2.abrupt("return", response.data);
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          throw _context2.t0;
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _publishUserSteps.apply(this, arguments);
}
function publishTypeErrorLogs(_x3) {
  return _publishTypeErrorLogs.apply(this, arguments);
}
function _publishTypeErrorLogs() {
  _publishTypeErrorLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(publishLogsRequest) {
    var response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return axios.post('https://v11-tfw-api.codeparva.com/configurations/publish-logs', {
            'logGroup': 'v10-tfw-logs',
            'logStream': 'general-errors',
            'logMessage': {
              'CID': publishLogsRequest.cid,
              'error': publishLogsRequest.error,
              'message': publishLogsRequest.message
            }
          });
        case 3:
          response = _context3.sent;
          return _context3.abrupt("return", response.data);
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
          throw _context3.t0;
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _publishTypeErrorLogs.apply(this, arguments);
}

function createApiInstance(token, CID, exceptionCodes) {
  if (token === void 0) {
    token = '';
  }
  if (CID === void 0) {
    CID = '';
  }
  if (exceptionCodes === void 0) {
    exceptionCodes = [];
  }
  var API_KEY = process.env.API_KEY;
  if (!API_KEY) {
    throw new Error('API_KEY environment variable is missing.');
  }
  var instanceHeaders = {
    'ApiKey': API_KEY
  };
  if (token) {
    instanceHeaders['Authorization'] = "Bearer " + token;
  }
  var apiInstance = axios.create({
    baseURL: 'https://simapi.syrasoft.com/1/api',
    headers: instanceHeaders
  });
  apiInstance.interceptors.response.use(function (response) {
    var _response$data;
    var intErrorCode = ((_response$data = response.data) == null ? void 0 : _response$data.intErrorCode) || 1;
    if (intErrorCode !== 1 && !exceptionCodes.includes(intErrorCode)) {
      return Promise.resolve(handleError(intErrorCode));
    }
    if (response.data.ResultCode && response.data.ResultCode !== 1) {
      return Promise.resolve(handleAuthCode(response.data.ResultCode));
    }
    return {
      data: response.data,
      status: response.status
    };
  }, function (error) {
    var _error$response, _error$config, _error$config2;
    var errorMessage = (error == null || (_error$response = error.response) == null || (_error$response = _error$response.data) == null ? void 0 : _error$response.error) || error.message;
    var requestBody = (_error$config = error.config) == null ? void 0 : _error$config.data;
    var requestHeaders = (_error$config2 = error.config) == null ? void 0 : _error$config2.headers;
    // Parse the request body if it is a JSON string
    var parsedRequestBody;
    var parsedRequestHeaders;
    try {
      parsedRequestBody = JSON.parse(requestBody);
    } catch (e) {
      // If parsing fails, use the original request body
      parsedRequestBody = requestBody;
    }
    try {
      parsedRequestHeaders = JSON.parse(requestHeaders);
    } catch (e) {
      // If parsing fails, use the original request body
      parsedRequestHeaders = requestHeaders;
    }
    var errorObject = {
      cid: CID,
      error: errorMessage,
      headers: parsedRequestHeaders,
      requestBody: parsedRequestBody,
      response: error == null ? void 0 : error.response
    };
    try {
      publishApiLogs(errorObject);
    } catch (apiError) {
      console.error('Error while making an api call', error);
    }
    return Promise.resolve({
      data: _extends({}, error.response.data, {
        blnSuccess: false
      }),
      status: error.response.status
    });
  });
  return apiInstance;
}
var handleError = function handleError(intErrorCode) {
  switch (intErrorCode) {
    case 0:
      return new Error('Unknown error occurred.');
    case 2:
      return new Error('Generic error occurred');
    case 3:
      return new Error('Access denied.');
    case 4:
      return new Error('Operation not supported');
    case 5:
      return new Error('Login is required');
    case 6:
      return new Error('Authentication service is unavailable');
    case 7:
      return new Error('Invalid token');
    default:
      return new Error("Unhandled error code: " + intErrorCode);
  }
};
var handleAuthCode = function handleAuthCode(authResultCode) {
  switch (authResultCode) {
    case 0:
      return new Error('Unknown error occurred');
    case 2:
      return new Error('Failed to login');
    case 3:
      return new Error('Invalid credentials');
    case 4:
      return new Error('Tenant is restricted');
    default:
      return new Error("Unhandled error code: " + authResultCode);
  }
};

var authEndpoints = {
  signin: 'auth/signin',
  signOut: 'auth/signout',
  changePassword: 'auth/changepassword',
  verifyEmail: 'auth/verifyemail',
  verifyCode: 'auth/verifycode',
  resetPassword: 'auth/resetpassword'
};

function signin(_x) {
  return _signin.apply(this, arguments);
}
function _signin() {
  _signin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(authRequest) {
    var apiInstance, signin, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', authRequest.cid);
          signin = authEndpoints.signin;
          _context.next = 4;
          return apiInstance.post(signin, {
            'intAuthMethod': 1,
            'strUserName': authRequest.strUserName,
            'strPassword': authRequest.strPassword
          });
        case 4:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _signin.apply(this, arguments);
}

function signout(_x) {
  return _signout.apply(this, arguments);
}
function _signout() {
  _signout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signOutRequest) {
    var token, cid, apiInstance, signOut, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          token = signOutRequest.token, cid = signOutRequest.cid;
          apiInstance = createApiInstance(token, cid);
          signOut = authEndpoints.signOut;
          _context.next = 5;
          return apiInstance.post(signOut, {});
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _signout.apply(this, arguments);
}

function changePassword(_x) {
  return _changePassword.apply(this, arguments);
}
function _changePassword() {
  _changePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(changePasswordRequest) {
    var token, cid, apiInstance, changePassword, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          token = changePasswordRequest.token, cid = changePasswordRequest.cid;
          apiInstance = createApiInstance(token, cid);
          changePassword = authEndpoints.changePassword;
          _context.prev = 3;
          _context.next = 6;
          return apiInstance.post(changePassword, {
            'confirmPassword': changePasswordRequest.confirmPassword,
            'strNewPassword': changePasswordRequest.strNewPassword,
            'strOldPassword': changePasswordRequest.strOldPassword
          });
        case 6:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          throw _context.t0;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _changePassword.apply(this, arguments);
}

function resetPassword(_x) {
  return _resetPassword.apply(this, arguments);
}
function _resetPassword() {
  _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resetPasswordRequest) {
    var apiInstance, resetPassword, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', resetPasswordRequest.cid);
          resetPassword = authEndpoints.resetPassword;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(resetPassword, {
            'strNewPassword': resetPasswordRequest.strNewPassword,
            'emailID': resetPasswordRequest.emailID,
            'strPasswordToken': resetPasswordRequest.strPasswordToken
          });
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _resetPassword.apply(this, arguments);
}

function verifyCode(_x) {
  return _verifyCode.apply(this, arguments);
}
function _verifyCode() {
  _verifyCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(verifyCodeRequest) {
    var apiInstance, verifyCode, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', verifyCodeRequest.cid);
          verifyCode = authEndpoints.verifyCode;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(verifyCode, {
            'strEmailID': verifyCodeRequest.strEmailID,
            'strPasswordToken': verifyCodeRequest.strPasswordToken
          });
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _verifyCode.apply(this, arguments);
}

function verifyEmail(_x) {
  return _verifyEmail.apply(this, arguments);
}
function _verifyEmail() {
  _verifyEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(verifyEmailRequest) {
    var apiInstance, verifyEmail, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', verifyEmailRequest.cid);
          verifyEmail = authEndpoints.verifyEmail;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(verifyEmail, {
            'strEmailID': verifyEmailRequest.strEmailID
          });
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _verifyEmail.apply(this, arguments);
}

var facilityEndpoints = {
  fetchUnitTypes: 'facility/unittypes',
  insuranceChoices: 'facility/insurancechoices',
  rentalPeriods: 'facility/rentalperiods',
  paymentMethods: 'facility/paymethods',
  calculateSurCharge: 'facility/calcsurcharge',
  leadDays: 'setting/leaddays'
};

function getUnitTypes(_x) {
  return _getUnitTypes.apply(this, arguments);
}
function _getUnitTypes() {
  _getUnitTypes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cid) {
    var apiInstance, fetchUnitTypes, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', cid);
          fetchUnitTypes = facilityEndpoints.fetchUnitTypes;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.get(fetchUnitTypes);
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getUnitTypes.apply(this, arguments);
}

function getRentalPeriods(_x) {
  return _getRentalPeriods.apply(this, arguments);
}
function _getRentalPeriods() {
  _getRentalPeriods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cid) {
    var apiInstance, rentalPeriods, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', cid);
          rentalPeriods = facilityEndpoints.rentalPeriods;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.get(rentalPeriods);
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getRentalPeriods.apply(this, arguments);
}

function getPaymentMethod(_x) {
  return _getPaymentMethod.apply(this, arguments);
}
function _getPaymentMethod() {
  _getPaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cid) {
    var apiInstance, paymentMethods, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', cid);
          paymentMethods = facilityEndpoints.paymentMethods;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.get(paymentMethods);
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getPaymentMethod.apply(this, arguments);
}

function getSurchargesAmount(_x) {
  return _getSurchargesAmount.apply(this, arguments);
}
function _getSurchargesAmount() {
  _getSurchargesAmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(calSurchargeReq) {
    var apiInstance, calculateSurCharge, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', calSurchargeReq.cid);
          calculateSurCharge = facilityEndpoints.calculateSurCharge;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.get(calculateSurCharge + "?idpaytype=" + calSurchargeReq.paymentMethodId + "&amt=" + calSurchargeReq.amount);
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getSurchargesAmount.apply(this, arguments);
}

function getInsuranceChoices(_x) {
  return _getInsuranceChoices.apply(this, arguments);
}
function _getInsuranceChoices() {
  _getInsuranceChoices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cid) {
    var apiInstance, insuranceChoices, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', cid);
          insuranceChoices = facilityEndpoints.insuranceChoices;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.get(insuranceChoices);
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getInsuranceChoices.apply(this, arguments);
}

function getLeadDays(_x) {
  return _getLeadDays.apply(this, arguments);
}
function _getLeadDays() {
  _getLeadDays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cid) {
    var apiInstance, leadDays, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', cid);
          leadDays = facilityEndpoints.leadDays;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.get(leadDays);
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getLeadDays.apply(this, arguments);
}

function contactFacility(_x) {
  return _contactFacility.apply(this, arguments);
}
function _contactFacility() {
  _contactFacility = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(contents) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          response = axios.post('https://emailsvc-ext.syrasoft.com/v1/email', contents);
          return _context.abrupt("return", response);
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          throw _context.t0;
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _contactFacility.apply(this, arguments);
}

var moveInEndpoints = {
  moveIn: 'movein',
  moveInCharges: 'movein/charges',
  reserve: 'movein/reserve'
};

function performMoveIn(_x) {
  return _performMoveIn.apply(this, arguments);
}
function _performMoveIn() {
  _performMoveIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(moveInReq) {
    var apiInstance, moveIn, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(moveInReq.token, moveInReq.cid);
          moveIn = moveInEndpoints.moveIn;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(moveIn, {
            blnGenerateDocuments: moveInReq.generateDocument,
            dteMoveIn: moveInReq.moveInDate,
            intUnitTypeID: moveInReq.unitTypeID
          });
        case 5:
          response = _context.sent;
          publishUserSteps({
            cid: moveInReq.cid,
            message: 'Tenant created successfully and move in performed successfully'
          });
          return _context.abrupt("return", response.data);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _performMoveIn.apply(this, arguments);
}

function getMoveInCharges(_x) {
  return _getMoveInCharges.apply(this, arguments);
}
function _getMoveInCharges() {
  _getMoveInCharges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(moveInChargesReq) {
    var apiInstance, moveInCharges, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', moveInChargesReq.cid);
          moveInCharges = moveInEndpoints.moveInCharges;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(moveInCharges, {
            "dteStartDate": moveInChargesReq.dteStartDate,
            "intInsuranceID": moveInChargesReq.intInsuranceID,
            "intPeriodID": moveInChargesReq.intPeriodID,
            "intUnitTypeID": moveInChargesReq.intUnitTypeID
          });
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _getMoveInCharges.apply(this, arguments);
}

function performReservation(_x) {
  return _performReservation.apply(this, arguments);
}
function _performReservation() {
  _performReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reserveReq) {
    var apiInstance, reserve, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(reserveReq.token, reserveReq.cid);
          reserve = moveInEndpoints.reserve;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(reserve, {
            "dteMoveIn": reserveReq.reserveDate,
            "intUnitTypeID": reserveReq.unitTypeID
          });
        case 5:
          response = _context.sent;
          publishUserSteps({
            cid: reserveReq.cid,
            message: 'Tenant created successfully and reservation performed successfully'
          });
          return _context.abrupt("return", response.data);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _performReservation.apply(this, arguments);
}

var paymentEndpoints = {
  authKey: 'payment/authkey',
  payment: 'payment',
  syraPayPayment: 'payment/hosted'
};

function getAuthKey(_x) {
  return _getAuthKey.apply(this, arguments);
}
function _getAuthKey() {
  _getAuthKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(authKeyReq) {
    var apiInstance, authKey, authKeyRequest, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(authKeyReq.token, authKeyReq.cid);
          authKey = paymentEndpoints.authKey;
          _context.prev = 2;
          authKeyRequest = {
            "blnForAutoPay": authKeyReq.blnForAutopay
          };
          if (authKeyReq != null && authKeyReq.amount) {
            authKeyRequest["decPaymentAmount"] = authKeyReq.amount;
          }
          _context.next = 7;
          return apiInstance.post(authKey, authKeyRequest);
        case 7:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 11]]);
  }));
  return _getAuthKey.apply(this, arguments);
}

function syraPayPayment(_x) {
  return _syraPayPayment.apply(this, arguments);
}
function _syraPayPayment() {
  _syraPayPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(syraPayReq) {
    var apiInstance, syraPayPayment, requestBody, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(syraPayReq.token, syraPayReq.cid, [2]);
          syraPayPayment = paymentEndpoints.syraPayPayment;
          _context.prev = 2;
          requestBody = {
            "objPayment": {
              "PaymentAmountTotal": syraPayReq.paymentAmountTotal,
              "PaymentAmount": syraPayReq.paymentAmount,
              "PayType": {
                "PayTypeID": syraPayReq.paymentTypeId,
                "PayTypeDescription": syraPayReq.paymentDescription
              }
            },
            "blnUseTokenOnFile": syraPayReq.useTokenOnFile,
            "blnGenerateDocs": syraPayReq.generateDocs
          };
          if (syraPayReq != null && syraPayReq.hostedGatewayResponse) {
            requestBody['strHostedGatewayResponse'] = syraPayReq.hostedGatewayResponse;
          }
          if (syraPayReq != null && syraPayReq.useTokenOnFile) {
            requestBody.objPayment['CCAccountNumber'] = syraPayReq.accountNumber || '';
            requestBody.objPayment['CCAccountName'] = syraPayReq.accountName || '';
            requestBody.objPayment['CCExpirationMonth'] = (syraPayReq == null ? void 0 : syraPayReq.expirationMonth) || '';
            requestBody.objPayment['CCExpirationYear'] = (syraPayReq == null ? void 0 : syraPayReq.expirationYear) || '';
            requestBody.objPayment['CCAccountCVV2'] = (syraPayReq == null ? void 0 : syraPayReq.cvv2) || '';
            requestBody.objPayment['CCAccountBillingAddress'] = (syraPayReq == null ? void 0 : syraPayReq.billingAddress) || '';
            requestBody.objPayment['CCAccountZIP'] = (syraPayReq == null ? void 0 : syraPayReq.zip) || '';
            requestBody.objPayment['SignUpForAutoPay'] = (syraPayReq == null ? void 0 : syraPayReq.signUpForAutoPay) || false;
          }
          _context.next = 10;
          return apiInstance.post(syraPayPayment, requestBody);
        case 10:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 14]]);
  }));
  return _syraPayPayment.apply(this, arguments);
}

function payment(_x) {
  return _payment.apply(this, arguments);
}
function _payment() {
  _payment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(paymentRequest) {
    var apiInstance, payment, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(paymentRequest.token, paymentRequest.cid);
          payment = paymentEndpoints.payment;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(payment, {
            "objPayment": {
              "CCAccountNumber": paymentRequest.accountName,
              "CCAccountName": paymentRequest.accountName,
              "CCExpirationMonth": paymentRequest.expirationMonth,
              "CCExpirationYear": paymentRequest.expirationYear,
              "CCAccountCVV2": paymentRequest.cvv,
              "CCAccountBillingAddress": paymentRequest.billingAddress,
              "CCAccountZIP": paymentRequest.zip,
              "SignUpForAutoPay": paymentRequest.signUpForAutoPay,
              "SavePaymentInfo": paymentRequest.savePaymentInfo,
              "PaymentAmount": paymentRequest.paymentAmount,
              "PayType": {
                "PayTypeID": paymentRequest.paymentTypeId,
                "PayTypeDescription": paymentRequest.paymentDescription
              }
            },
            "blnGenerateDocs": true
          });
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _payment.apply(this, arguments);
}

var tenantEndpoints = {
  tenantInfo: "tenant",
  createTenant: "tenant/add",
  autoPaySignUp: "tenant/autopaysignup",
  syraPayAutoPaySignUp: "tenant/hostedautopaysignup",
  autoPayOptOut: "tenant/autopayoptout"
};

function fetchTenantInfo(_x) {
  return _fetchTenantInfo.apply(this, arguments);
}
function _fetchTenantInfo() {
  _fetchTenantInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fetchTenantReq) {
    var apiInstance, tenantInfo, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(fetchTenantReq.token, fetchTenantReq.cid);
          tenantInfo = tenantEndpoints.tenantInfo;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.get(tenantInfo);
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _fetchTenantInfo.apply(this, arguments);
}

function createTenant(_x) {
  return _createTenant.apply(this, arguments);
}
function _createTenant() {
  _createTenant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tenantCreateRq) {
    var apiInstance, createTenant, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance('', tenantCreateRq.cid);
          createTenant = tenantEndpoints.createTenant;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(createTenant, {
            "objTenant": _extends({}, tenantCreateRq.tenantInfo)
          });
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _createTenant.apply(this, arguments);
}

function updateTenant(_x) {
  return _updateTenant.apply(this, arguments);
}
function _updateTenant() {
  _updateTenant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tenantUpdateReq) {
    var apiInstance, tenantInfo, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(tenantUpdateReq.token, tenantUpdateReq.cid);
          tenantInfo = tenantEndpoints.tenantInfo;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(tenantInfo, {
            "objTenant": _extends({}, tenantUpdateReq.tenantInfo)
          });
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _updateTenant.apply(this, arguments);
}

function autoPayOptOut(_x) {
  return _autoPayOptOut.apply(this, arguments);
}
function _autoPayOptOut() {
  _autoPayOptOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(autoPayOptOutReq) {
    var apiInstance, autoPayOptOut, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(autoPayOptOutReq.token, autoPayOptOutReq.cid);
          autoPayOptOut = tenantEndpoints.autoPayOptOut;
          _context.prev = 2;
          _context.next = 5;
          return apiInstance.post(autoPayOptOut, {});
        case 5:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _autoPayOptOut.apply(this, arguments);
}

function signUpForAutoPay(_x) {
  return _signUpForAutoPay.apply(this, arguments);
}
function _signUpForAutoPay() {
  _signUpForAutoPay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(autoPaySignUpReq) {
    var apiInstance, autoPaySignUp, signUpReq, CCBillingAccountName, CCBillingAddress, CCBillingZIP, CCExpirationMonth, CCExpirationYear, CCNumber, payTypeDescription, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(autoPaySignUpReq.token, autoPaySignUpReq.cid);
          autoPaySignUp = tenantEndpoints.autoPaySignUp;
          _context.prev = 2;
          signUpReq = {
            "SignUpForAutoPay": autoPaySignUpReq.SignUpForAutoPay,
            "intPreferredPaymentMethod": autoPaySignUpReq.intPreferredPaymentMethod
          };
          if (autoPaySignUpReq != null && autoPaySignUpReq.strHostedGatewayResponse) {
            signUpReq['strHostedGatewayResponse'] = autoPaySignUpReq == null ? void 0 : autoPaySignUpReq.strHostedGatewayResponse;
          }
          if (autoPaySignUpReq != null && autoPaySignUpReq.CCBillingAccountName) {
            CCBillingAccountName = autoPaySignUpReq.CCBillingAccountName, CCBillingAddress = autoPaySignUpReq.CCBillingAddress, CCBillingZIP = autoPaySignUpReq.CCBillingZIP, CCExpirationMonth = autoPaySignUpReq.CCExpirationMonth, CCExpirationYear = autoPaySignUpReq.CCExpirationYear, CCNumber = autoPaySignUpReq.CCNumber, payTypeDescription = autoPaySignUpReq.payTypeDescription;
            signUpReq["CCBillingAccountName"] = CCBillingAccountName;
            signUpReq["CCBillingAddress"] = CCBillingAddress;
            signUpReq["CCBillingZIP"] = CCBillingZIP;
            signUpReq["CCExpirationMonth"] = CCExpirationMonth;
            signUpReq["CCExpirationYear"] = CCExpirationYear;
            signUpReq["CCNumber"] = CCNumber;
            signUpReq["PayType"] = {
              "PayTypDescription": payTypeDescription,
              "PayTypeID": autoPaySignUpReq.intPreferredPaymentMethod
            };
          }
          _context.next = 8;
          return apiInstance.post(autoPaySignUp, signUpReq);
        case 8:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12]]);
  }));
  return _signUpForAutoPay.apply(this, arguments);
}

function signUpForSyraPayAutoPay(_x) {
  return _signUpForSyraPayAutoPay.apply(this, arguments);
}
function _signUpForSyraPayAutoPay() {
  _signUpForSyraPayAutoPay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(autoPaySignUpReq) {
    var apiInstance, syraPayAutoPaySignUp, signUpReq, CCBillingAccountName, CCBillingAddress, CCBillingZIP, CCExpirationMonth, CCExpirationYear, CCNumber, payTypeDescription, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiInstance = createApiInstance(autoPaySignUpReq.token, autoPaySignUpReq.cid);
          syraPayAutoPaySignUp = tenantEndpoints.syraPayAutoPaySignUp;
          _context.prev = 2;
          signUpReq = {
            "SignUpForAutoPay": autoPaySignUpReq.SignUpForAutoPay,
            "intPreferredPaymentMethod": autoPaySignUpReq.intPreferredPaymentMethod
          };
          if (autoPaySignUpReq != null && autoPaySignUpReq.strHostedGatewayResponse) {
            signUpReq['strHostedGatewayResponse'] = autoPaySignUpReq == null ? void 0 : autoPaySignUpReq.strHostedGatewayResponse;
          }
          if (autoPaySignUpReq != null && autoPaySignUpReq.CCBillingAccountName) {
            CCBillingAccountName = autoPaySignUpReq.CCBillingAccountName, CCBillingAddress = autoPaySignUpReq.CCBillingAddress, CCBillingZIP = autoPaySignUpReq.CCBillingZIP, CCExpirationMonth = autoPaySignUpReq.CCExpirationMonth, CCExpirationYear = autoPaySignUpReq.CCExpirationYear, CCNumber = autoPaySignUpReq.CCNumber, payTypeDescription = autoPaySignUpReq.payTypeDescription;
            signUpReq["CCBillingAccountName"] = CCBillingAccountName;
            signUpReq["CCBillingAddress"] = CCBillingAddress;
            signUpReq["CCBillingZIP"] = CCBillingZIP;
            signUpReq["CCExpirationMonth"] = CCExpirationMonth;
            signUpReq["CCExpirationYear"] = CCExpirationYear;
            signUpReq["CCNumber"] = CCNumber;
            signUpReq["PayType"] = {
              "PayTypDescription": payTypeDescription,
              "PayTypeID": autoPaySignUpReq.intPreferredPaymentMethod
            };
          }
          _context.next = 8;
          return apiInstance.post(syraPayAutoPaySignUp, signUpReq);
        case 8:
          response = _context.sent;
          return _context.abrupt("return", response.data);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          throw _context.t0;
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12]]);
  }));
  return _signUpForSyraPayAutoPay.apply(this, arguments);
}

export { autoPayOptOut, changePassword, contactFacility, createTenant, fetchTenantInfo, getAuthKey, getInsuranceChoices, getLeadDays, getMoveInCharges, getPaymentMethod, getRentalPeriods, getSurchargesAmount, getUnitTypes, payment, performMoveIn, performReservation, publishApiLogs, publishTypeErrorLogs, publishUserSteps, resetPassword, signUpForAutoPay, signUpForSyraPayAutoPay, signin, signout, syraPayPayment, updateTenant, verifyCode, verifyEmail };
//# sourceMappingURL=v10-tfw-revamp-package-api.esm.js.map
